<template>
  <component
    :is="inputs[inputType]"
    :type="inputType === 'password' ? inputType : null"
    v-bind="{ ...$props, ...$attrs }"
  >
    <slot name="sub-buttons" />
    <template #left>
      <slot name="left" />
    </template>
    <template #right>
      <slot name="right" />
    </template>
  </component>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from "vue";
import type { IInput } from "@/components/Base/subcomponents/BaseInput/Input.vue";
import type { ITextarea } from "@/components/Base/subcomponents/BaseInput/Textarea.vue";
import type { ICheckbox } from "@/components/Base/subcomponents/BaseInput/Checkbox.vue";
import type { ISelectProp } from "@/components/Base/subcomponents/BaseInput/Select.vue";
import type { InputDatepicker } from "@/components/Base/subcomponents/BaseInput/Date.vue";
import type { IFileUploadProp } from "@/components/Base/subcomponents/BaseInput/FileUpload.vue";

export type InputType =
  | "text"
  | "textarea"
  | "password"
  | "number"
  | "select"
  | "checkbox"
  | "date"
  | "file";

export interface IBaseInputProps
  extends IInput,
    IFileUploadProp,
    InputDatepicker,
    ISelectProp,
    ICheckbox,
    ITextarea {
  inputType?: InputType;
}
export type IBaseInput = Partial<IBaseInputProps>;
defineOptions({
  inheritAttrs: false,
});
withDefaults(defineProps<Partial<IBaseInput>>(), {
  inputType: "text",
  swipeVisible: true,
  showInputErrorMessages: true,
  afterSaveSelectionClose: true,
  showNavigation: true,
  showRanges: true,
});

const inputs = {
  text: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/Input.vue")
  ),
  number: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/InputNumber.vue")
  ),
  select: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/Select.vue")
  ),
  date: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/Date.vue")
  ),
  checkbox: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/CheckboxGroup.vue")
  ),
  textarea: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/Textarea.vue")
  ),
  file: defineAsyncComponent(
    () => import("./subcomponents/BaseInput/FileUpload.vue")
  ),
};
</script>
